import React from "react";
import BlogTimelineItem from "./BlogTimelineItem";

const BlogTimeline = ({ blogs, lang, keyword }) => {
  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );
  return (
    <div className="relative max-w-7xl mx-auto">
      {/* Vertical line */}
      <div
        className="
          hidden lg:block
          absolute
          left-1/2
          top-0
          bottom-0
          w-[2px]
          bg-neonYellow
          -translate-x-1/2
        "
      />

      <div className="space-y-0 lg:space-y-36">
        {sortedBlogs.map((blog, index) => (
          <BlogTimelineItem
            key={blog.id}
            blog={blog}
            lang={lang}
            keyword={keyword}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogTimeline;
